module.exports = __webpack_public_path__ + "img/Al Sadeel.f0fffa2e.png";